/*
 *
 * GoogleCalendarManager constants
 *
 */

export const FETCH_CALENDARS_REQUEST = 'app/GoogleCalendarManager/FETCH_CALENDARS_REQUEST';
export const FETCH_CALENDARS_SUCCESS = 'app/GoogleCalendarManager/FETCH_CALENDARS_SUCCESS';
export const FETCH_CALENDARS_FAILURE = 'app/GoogleCalendarManager/FETCH_CALENDARS_FAILURE';

export const DELETE_CALENDAR_REQUEST = 'app/GoogleCalendarManager/DELETE_CALENDAR_REQUEST';
export const DELETE_CALENDAR_SUCCESS = 'app/GoogleCalendarManager/DELETE_CALENDAR_SUCCESS';
export const DELETE_CALENDAR_FAILURE = 'app/GoogleCalendarManager/DELETE_CALENDAR_FAILURE';

export const CANCEL_FETCH_CALENDARS = 'app/GoogleCalendarManager/CANCEL_FETCH_CALENDARS';

